import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const TopAnalystsStocksCanada = () => {
  const [stocks, setStocks] = useState(() => {
    const savedStocks = sessionStorage.getItem("top-analysts-stocks-ca");
    return savedStocks ? JSON.parse(savedStocks) : [];
  });
  const [filteredStocks, setFilteredStocks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchText, setSearchText] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (stocks.length > 0) {
      setFilteredStocks(stocks);
      setLoading(false);
      return;
    }
    const fetchStocks = async () => {
      try {
        const timeStamp = Date.now();
        const response = await axios.get(
          `https://tr-cdn.tipranks.com/research/prod/screener/analysts-top-stocks/canada/payload.json?ver=${timeStamp}`
        );
        const sortedStocks = response.data.TopRatedStocks.data.stocks.sort((a, b) => {
          //if (b.smartScore.value?.toFixed(0) !== a.smartScore.value?.toFixed(0)) {
            // a price targets
            const a_currentPrice = a.price;
            const a_consensus = a.analystRatings.consensus;
            const a_priceTarget = a_consensus?.priceTarget?.value;
            const a_priceTargetPercentage = (((a_priceTarget - a_currentPrice) / a_currentPrice) * 100).toFixed(0);

            // b price targets
            const b_currentPrice = b.price;
            const b_consensus = b.analystRatings.consensus;
            const b_priceTarget = b_consensus?.priceTarget?.value;
            const b_priceTargetPercentage = (((b_priceTarget - b_currentPrice) / b_currentPrice) * 100).toFixed(0);

            return b_priceTargetPercentage - a_priceTargetPercentage;
          //}
          //return b.smartScore.value?.toFixed(0) - a.smartScore.value?.toFixed(0);
        });
        setStocks(sortedStocks);
        setFilteredStocks(sortedStocks);
        sessionStorage.setItem("top-analysts-stocks-ca", JSON.stringify(sortedStocks));
        setLoading(false);
      } catch (err) {
        console.log(err);
        setError(`Failed to fetch stock data. ${err}`);
        setLoading(false);
      }
    };
    fetchStocks();
  }, []);

  if (loading) return <div className="text-center mt-3 text-light">Loading...</div>;
  if (error) return <div className="text-center mt-3 text-danger">{error}</div>;

  return (
    <div className="table-container text-light">
      <h6 className="mb-4">Top Analysts Stocks 🇨🇦</h6>
      <div class="d-flex justify-content-center mb-4">
        <div class="col-md-3">
          <input
            type="text"
            class="form-control"
            id="search_text"
            placeholder="Search"
            onChange={(e) => {
              const searchText = e.target.value;
              setFilteredStocks(
                stocks.filter(
                  (i) => i.ticker.toLowerCase().includes(searchText) || i.name.toLowerCase().includes(searchText)
                )
              );
              setSearchText(searchText);
            }}
          ></input>
        </div>
      </div>
      <div
        style={{
          maxHeight: "85vh",
          overflowY: "auto",
          overflowX: "scroll",
        }}
      >
        <table className="table table-striped table-bordered table-dark w-100">
          <thead
            style={{
              position: "sticky",
              top: 0,
              background: "#212529",
              zIndex: 1,
            }}
          >
            <tr>
              <th scope="col">Ticker</th>
              <th scope="col">Name</th>
              <th scope="col">Sector</th>
              <th scope="col">Price</th>
              <th scope="col">Target</th>
              <th scope="col">Low</th>
              <th scope="col">High</th>
              <th scope="col">Tiprank Score</th>
              <th scope="col">AI Score</th>
              <th scope="col">M. Cap</th>
              <th scope="col">Investor</th>
              <th scope="col">Hedge</th>
              <th scope="col">Analyst</th>
              <th scope="col">Buy</th>
              <th scope="col">Sell</th>
              <th scope="col">Hold</th>
            </tr>
          </thead>
          <tbody>
            {filteredStocks.map((stock, index) => {
              const currentPrice = stock.price;
              const analystRating = stock.analystRatings ?? {};

              // price targets
              const consensus = stock.analystRatings.consensus ?? {};

              const priceTarget = consensus?.priceTarget?.value ?? currentPrice;
              const priceTargetPercentage = (((priceTarget - currentPrice) / currentPrice) * 100).toFixed(0);

              const priceTargetHigh = consensus?.highPriceTarget;
              const priceTargetHighPercentage = (((priceTargetHigh - currentPrice) / currentPrice) * 100).toFixed(0);

              const priceTargetLow = consensus?.lowPriceTarget ?? currentPrice;
              const priceTargetLowPercentage = (((priceTargetLow - currentPrice) / currentPrice) * 100).toFixed(0);

              const investorSentimentScore = stock.investorActivity?.best?.score?.toFixed(1);

              const analystBuyRating = consensus?.id;

              const hedgeFundSignal = stock.hedgeFundActivity.signal?.toFixed(1);

              const score = stock.smartScore.value?.toFixed(0);
              const goodScore = score > 8;

              const aiScore = stock.report?.score;

              return (
                <tr
                  key={index}
                  onClick={() => navigate(`/stocks/${stock.ticker}`, { state: { stock } })}
                  style={{ cursor: "pointer" }}
                >
                  <td>{stock.ticker}</td>
                  <td>{stock.name}</td>
                  <td>{stock.sector}</td>
                  <td>${currentPrice.toFixed(2)}</td>
                  <td style={{ color: priceTargetPercentage > 0 ? "green" : "red" }}>{priceTargetPercentage}%</td>
                  <td style={{ color: priceTargetLowPercentage > 0 ? "green" : "red" }}>{priceTargetLowPercentage}%</td>
                  <td style={{ color: priceTargetHighPercentage > 0 ? "green" : "red" }}>
                    {priceTargetHighPercentage}%
                  </td>

                  <td style={{ color: goodScore ? "green" : "red" }}>{score ?? "-"}</td>
                  <td style={{ color: aiScore > 49 ? "green" : "red" }}>{aiScore}</td>
                  <td>${(stock.marketCap / 1000000000).toFixed(2)}B</td>
                  <td
                    style={{
                      color: investorSentimentScore > 0.5 ? "green" : "red",
                    }}
                  >
                    {investorSentimentScore}
                  </td>
                  <td
                    style={{
                      color: hedgeFundSignal > 0.5 ? "green" : "red",
                    }}
                  >
                    {hedgeFundSignal}
                  </td>
                  <td style={{ color: analystBuyRating === "strongBuy" ? "green" : "" }}>{analystBuyRating}</td>
                  <td>{analystRating.bestConsensus?.buy}</td>
                  <td style={{ color: analystRating.bestConsensus?.sell > 0 ? "red" : "" }}>
                    {analystRating?.bestConsensus?.sell}
                  </td>
                  <td style={{ color: analystRating.bestConsensus?.hold > 0 ? "red" : "" }}>
                    {analystRating.bestConsensus?.hold}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TopAnalystsStocksCanada;
